/**
 * In-memory access token store for Auth Phase 2.
 * Access token is kept in memory only; refresh token is in HttpOnly cookie.
 * Used by getApiHeaders() so API calls send the current access token.
 */
let _accessToken = null;

export function getAccessToken() {
  return _accessToken;
}

export function setAccessToken(token) {
  _accessToken = token;
}

export function clearAccessToken() {
  _accessToken = null;
}

/** Decode JWT payload (middle segment). Tries localStorage `vantio_token`, then in-memory token. */
export function getTokenPayload() {
  let token = null;
  if (typeof localStorage !== "undefined") {
    token = localStorage.getItem("vantio_token");
  }
  if (!token) {
    token = getAccessToken();
  }
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch {
    return null;
  }
}
